import React, { useRef, useState } from "react";
import {
  Box,
  Typography,
  Avatar,
  Button,
  Chip,
  Card,
  CardContent,
  Divider,
  useTheme, IconButton,
  TextField,
  useMediaQuery
} from "@mui/material";
import ShareIcon from "@mui/icons-material/Share";
import { useParams } from "react-router-dom";
import { typography } from "app/utils/constant";
import useAuth from "app/hooks/useAuth";
import { Field, Form, Formik } from "formik";
  // import CancelPresentationIcon from '@mui/icons-material/CancelPresentation';
import CloseIcon from "@mui/icons-material/Close";
import ShareMenu from "app/components/ShareButton";
import ApplyShareMenu from "app/components/ApplySharebutton";

// Dummy data (can be replaced with API response)
const jobData = {
  user: {
    name: "Sanya Patel",
    timeAgo: "45 minutes ago",
    role: "Gig",
    avatar: "https://i.pravatar.cc/100", // placeholder image
  },
  gig: {
    title: "Video Editor",
    Location: "Chennai",
    project: "Project Name",
    description:
      "Stripe is looking for Social Media Marketing expert to help manage our online networks. You will be responsible for monitoring our social media channels, creating content, finding effective ways to engage the community and incentivize others to engage on our channels.",
    referenceImg:
      "https://images.unsplash.com/photo-1507525428034-b723cf961d3e?auto=format&fit=crop&w=600&q=60",
    requiredSkills: [
      "Project Management",
      "Copywriting",
      "Social Media Marketing",
      "English",
      "Video Editing",
    ],
  },
  roleDetails: {
    applyBefore: "July 31, 2021",
    compensation: "Project basis",
    duration: "6 Hours for 5 days",
    salary: "$75000-$85000",
    status: "Post Production",
    // workMethod: "On-site",
    // nda: "Required",
    // reference: "Required",
  },
  similarJobs: [
    {
      title: "Video Editor",
      Location: "Chennai",
      type: "On-site",
      tags: ["Marketing", "Design"],
    },
  ],
};

const JobDetails = ({ job, OnClose, OnApply, gigWorkData, internshipData, apprenticeshipData, JobData }) => {
  console.log("🚀 ~ JobDetails ~ job:", job);
  const params = useParams();
  const { user } = useAuth();
  console.log("🚀 ~ JobDetails ~ user:", user)
  console.log("🚀 ~ JobDetails ~ params:", job.SourceType);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  if (!job) {
    return (
      <Box sx={{ p: 3, textAlign: "center" }}>
        <Typography color="text.secondary">Loading job details...</Typography>
      </Box>
    );
  }

// const initialValues = {};
//   JobData?.questions.forEach(q => {
//     initialValues[q.RecordID] = "";
//   });

  const handleSubmit = (values) => {
    const formattedAnswers = {
      Answers:JobData?.questions.map(q => ({
        QuestionID: q.RecordID,
        Answer: values[q.RecordID]
      }))
    };

    console.log(formattedAnswers);
  };
  return (
    <Box
      // sx={{
      //   width: "100%",
      //   mx: "auto",
      //   p: 2,
      //   pb: 8,
      //   backgroundColor: theme.palette.card,
      // }}
       sx={{
    width: "100%",
    mx: "auto",
    p: isMobile ? 1.5 : 2,
    pb: isMobile ? 10 : 8,
    backgroundColor: theme.palette.card,
  }}
    >
      {/* User Info */}
      {job.SourceType === "GW" && (
        <>
                  <Box 
                  // display="flex" 
                  // alignItems="center" 
                  // justifyContent="space-between" 
                  // mb={2}
                    display="flex"
  alignItems={isMobile ? "flex-start" : "center"}
  justifyContent="space-between"
  flexDirection={isMobile ? "column" : "row"}
  gap={isMobile ? 1.5 : 2}
  mb={2}
                  >

  {/* LEFT SIDE */}
  <Box display="flex" alignItems="center" gap={2} width="100%">
    <Avatar src={gigWorkData.ProfileImage} />

    <Box flexGrow={1}>
      <Typography
        sx={{
          ...typography.h4Bold,
            fontSize: isMobile ? "1rem" : "1.25rem",
          color: theme.palette.primary.contrastText,
        }}
      >
        {gigWorkData.UserName}
      </Typography>

      <Typography
        sx={{
          ...typography.bodyMedium,
          color: theme.palette.info.main,
        }}
      >
        {gigWorkData.PostDuration}
      </Typography>
    </Box>

    <Chip
      label={"GIG"}
      size={isMobile ? "small" : "medium"}
      sx={{
        color: theme.palette.buttons.primary.text,
        bgcolor: theme.palette.success.main,
      }}
    />
  </Box>

  {/* RIGHT SIDE ACTIONS */}
<Box 
display="flex" gap={1} width={isMobile ? "100%" : "auto"}
// display="flex" 
// alignItems="center" 
// gap={1}
>
  
  {/* Share Menu Button */}
  {/* <Box
    sx={{
      width: 32,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "20%",
      bgcolor: "#E3F2FD",
      color: "#1976d2",
      cursor: "pointer",
    }}
  >
    <ApplyShareMenu url={gigWorkData.ShareLink} />
  </Box> */}

  {/* Close Button */}
  <Button
    variant="contained"
     fullWidth={isMobile}
    onClick={OnClose}
    sx={{
      // minWidth: 40,
      // width: 30,
      // height: 30,
      // borderRadius: "20%",
           height: 36,
        borderRadius: "10px",
      backgroundColor: "#c90c4eff",
      color: "white",
      "&:hover": {
        backgroundColor: "#c90c4eff",
      },
    }}
  >
    <CloseIcon />
  </Button>
</Box>


</Box>
          {/* <Box display="flex" alignItems="center" gap={1} mb={2}>
            <Avatar src={gigWorkData.ProfileImage} />
            <Box>
              <Typography
                sx={{
                  ...typography.h4Bold,
                  color: theme.palette.primary.contrastText,
                }}
              >
                {gigWorkData.UserName}
              </Typography>
              <Typography
                sx={{
                  ...typography.bodyMedium,
                  color: theme.palette.info.main,
                }}
              >
                {gigWorkData.timeAgo}
              </Typography>
            </Box>
            <Chip
              label={job.SourceType === "GW" ? "GIG" : job.SourceType === "AP" ? "APRENTICESHIP" : "INTERNSHIP"}
              sx={{
                       color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.success.main, // ✅ proper success color
              }}
              size="small"
            />
<Button
  variant="contained"
  onClick={OnClose}
  sx={{
     ml: "auto",     
    minWidth: "40px",
    width: "30px",
    height: "30px",
    borderRadius: "20%",        // round icon button
    backgroundColor: "#c90c4eff",     // red background
                       color: theme.palette.buttons.primary.text,
    "&:hover": {
      backgroundColor: "#c90c4eff", // darker red on hover
    },
  }}
>
  <CloseIcon  />
</Button>

          </Box> */}

          {/* Gig Card */}
          <Card
            sx={{
              mb: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.border}`,
              bgcolor: theme.palette.card,
            }}
          >
            <CardContent>
                <Box
                  display="flex"
  flexDirection={isMobile ? "column" : "row"}
  alignItems={isMobile ? "flex-start" : "center"}
  justifyContent="space-between"
  gap={1}
                // sx={{
                //   display: "flex",
                //   alignItems: "center",
                //   justifyContent: "space-between",
                // }}
              >
              <Typography
                sx={{
                  ...typography.h2,
                   fontSize: isMobile ? "1.2rem" : "1.6rem",
                  color: theme.palette.primary.contrastText,
                }}
              >
                {gigWorkData.Title}
              </Typography>
                  <ApplyShareMenu url={gigWorkData.ShareLink} />
  </Box>
              <Typography
                sx={{
                  ...typography.buttonGhost,
                  color: theme.palette.primary.contrastText,
                }}
              >
                {gigWorkData.RoleName} • {gigWorkData.Location} •
                {gigWorkData.ProjectName}
              </Typography>
              {gigWorkData.Applied === true ? (
                <Button

                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                       "&:hover": {
                     color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Applied
                </Button>
              ) : (
                <Button
                  onClick={async () => {
                    const idata = {
                      "RecordID": gigWorkData.RecordID,
                      "UserID": user.UserID,
                      "Type": gigWorkData.SourceType //Apprenticeship , IN-Internship , GW -Gigwork , JC- Job
                    };

                    console.log("idata", idata);
                    OnApply(idata);


                  }}
                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                   "&:hover": {
                        color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Apply
                </Button>
              )}
            </CardContent>
          </Card>

          {/* Job Description */}
          <Typography
            sx={{
              ...typography.bodySmall,
              color: theme.palette.info.main,
            }}
          >
            Role Hiring
          </Typography>
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            {gigWorkData.Title}
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.secondary.contrastText,
            }}
            mb={2}
          >
            {gigWorkData.Description}
          </Typography>

          {/* Reference Image */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Reference Image
          </Typography>
          <Box
            component="img"
            src={gigWorkData.CoverImage}
            alt="Reference"
            sx={{
    width: "100%",
    maxHeight: isMobile ? 220 : 360,
    objectFit: "cover",
    borderRadius: 2,
    mb: 2,
  }}
            // width="100%"
            // borderRadius={2}
            // mb={2}
          />

          {/* Required Skills */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Required Skills
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
            {gigWorkData?.skills?.length > 0 ? (
              gigWorkData.skills.map((skill, i) => (
                <Chip
                  key={i}
                  label={skill.Name}
                  variant="outlined"
                  sx={{
                    ...typography.bodyLarge,
                    color: theme.palette.secondary.contrastText,
                    bgcolor: theme.palette.card,
                    borderColor: theme.palette.border,
                  }}
                />
              ))
            ) : (
              <Typography
                sx={{
                  ...typography.bodyLarge,
                  color: theme.palette.secondary.contrastText,
                }}
              >
                No skills listed.
              </Typography>
            )}
          </Box>


          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />

          {/* About this role */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            About this role
          </Typography>
          {/* {Object.entries(jobData.roleDetails).map(([key, value]) => ( */}
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Apply Before
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {gigWorkData.DeadLineDate}
            </Typography>
          </Box>

           {/*  <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
          <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Compensationhii
              {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")}
            </Typography> 
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {gigWorkData.Compensation}
            </Typography>
          </Box>*/}
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Duration
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {gigWorkData.Duration}
            </Typography>
          </Box>
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Salary
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {"₹" + gigWorkData.RateRange}
            </Typography>
          </Box>
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Production Status
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {gigWorkData.ProductionStatus}
            </Typography>
          </Box>
          {/* ))} */}

          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.secondary.contrastText,
            }}
          >
            Work Method
          </Typography>

          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,
            }}
          >
            {gigWorkData.WorkMethod}
          </Typography>
          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />
          {/* Similar Jobs */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.secondary.contrastText,
            }}
          >
            NdA
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,
            }}
          >
            Required
          </Typography>

          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />
          {/* Similar Jobs */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.secondary.contrastText,
            }}
          >
            Reference
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,
            }}
          >
            Required
          </Typography>
          <Box
            component="img"
            src={gigWorkData.ReferenceMedia}
            alt="Reference"
            width="100%"
            borderRadius={2}
            mb={2}
          />
          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />
          {/* Similar Jobs */}
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,
            }}
          >
            Similar Jobs
          </Typography>
          {/* {jobData.similarJobs.map((job, i) => (
        <Card key={i} sx={{ mt: 1, borderRadius: 2 }}>
          <CardContent>
            <Typography fontWeight="bold">{job.Title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {job.type} • {job.Location}
            </Typography>
            <Box display="flex" gap={1} mt={1}>
              {job.tags.map((tag, idx) => (
                <Chip key={idx} label={tag} size="small" />
              ))}
            </Box>
          </CardContent>
        </Card>
      ))} */}

          <Box
            display="flex"
            overflow="auto"
            gap={2}
            mt={2}
            sx={{
              "&::-webkit-scrollbar": { display: "none" }, // hide scrollbar
            }}
          >
            {jobData.similarJobs.map((job, i) => (
              <Card
                key={i}
                sx={{
                  flex: isMobile ? "0 0 90%" : "0 0 48%",     
                  borderRadius: 3,
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                  border: `1px solid ${theme.palette.border}`,
                  bgcolor: theme.palette.card,
                }}
              >
                <CardContent>
                  {/* Top Row */}
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Avatar
                      src={job.icon || "https://mui.com/static/logo.png"}
                      sx={{ width: 32, height: 32 }}
                    />
                    <Chip
                      label="GIG"
                      size="small"
                      sx={{
                        backgroundColor: "#E6FAF3",
                        color: "#00A67E",
                        fontWeight: "bold",
                      }}
                    />
                  </Box>

                  {/* Title */}
                  <Typography
                    sx={{
                      ...typography.h4,
                      color: theme.palette.secondary.contrastText,
                    }}
                    mt={1}
                  >
                    {job.Title}
                  </Typography>

                  {/* Location */}
                  <Typography
                    sx={{
                      ...typography.bodyLarge,
                      color: theme.palette.primary.contrastText,
                    }}
                  >
                    {job.type} •{" "}
                    <span
                      style={{
                        ...typography.bodyLarge,
                        color: theme.palette.secondary.main,
                      }}
                    >
                      {job.Location}
                    </span>
                  </Typography>

                  {/* Tags */}
                  <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                    {job.tags.map((tag, idx) => (
                      <Chip
                        key={idx}
                        label={tag}
                        size="small"
                        sx={{
                          borderRadius: "20px",
                          border: "1px solid",
                          borderColor: idx % 2 === 0 ? "#FFB84D" : "#6C63FF",
                          color: idx % 2 === 0 ? "#FFB84D" : "#6C63FF",
                          backgroundColor: "transparent",
                          fontWeight: "500",
                        }}
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box>
          {gigWorkData.Applied === true ? (
            <Button

              fullWidth
              variant="contained"
              sx={{
                ...typography.buttonPrimaryLarge,
                color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                mt: 3,
                borderRadius: "10px",
                  "&:hover": {
                         color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                      },
              }}
            >
              Applied
            </Button>
          ) : (
            <Button
              onClick={async () => {
                const idata = {
                  "RecordID": gigWorkData.RecordID,
                  "UserID": user.UserID,
                  "Type": gigWorkData.SourceType //Apprenticeship , IN-Internship , GW -Gigwork , JC- Job
                };

                console.log("idata", idata);

                try {
                  const response = await OnApply(idata);

                  if (response?.payload?.Status === "Y") {
                    //setButtonName("Applied");
                    // setIsfollow(!isfollow);
                    // onFollowChange?.(data.UserID, !isfollow);
                  }
                } catch (err) {
                  console.error(err);

                }
              }}
              fullWidth
              variant="contained"
              sx={{
                ...typography.buttonPrimaryLarge,
                color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                mt: 3,
                borderRadius: "10px",
                 "&:hover": {
                      color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                      },
              }}
            >
              Apply
            </Button>
          )}
        </>
      )}
      {job.SourceType === "AP" && (
        <>
               <Box 
                 display="flex"
  alignItems={isMobile ? "flex-start" : "center"}
  justifyContent="space-between"
  flexDirection={isMobile ? "column" : "row"}
  gap={isMobile ? 1.5 : 2}
  mb={2}
                  >

  {/* LEFT SIDE */}
  <Box display="flex" alignItems="center" gap={2} width="100%">
    <Avatar src={apprenticeshipData.ProfileImage} />

     <Box flexGrow={1}>
      <Typography
        sx={{
          ...typography.h4Bold,
          color: theme.palette.primary.contrastText,
        }}
      >
        {apprenticeshipData.UserName}
      </Typography>

      <Typography
        sx={{
          ...typography.bodyMedium,
          color: theme.palette.info.main,
        }}
      >
        {apprenticeshipData.PostDuration}
      </Typography>
    </Box>

    <Chip
     label={"APRENTICESHIP"}

      // label={
      //   apprenticeshipData.SourceType === "JC"
      //     ? "JOB"
      //     : apprenticeshipData.SourceType === "AP"
      //     ? "APRENTICESHIP"
      //     : "INTERNSHIP"
      // }
      size={isMobile ? "small" : "medium"}
      sx={{
        color: theme.palette.buttons.primary.text,
        bgcolor: theme.palette.success.main,
      }}
    />
  </Box>

  {/* RIGHT SIDE ACTIONS */}
<Box 
display="flex" gap={1} width={isMobile ? "100%" : "auto"}
>  
  {/* Share Menu Button */}
  {/* <Box
    sx={{
      width: 32,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "20%",
      bgcolor: "#E3F2FD",
      color: "#1976d2",
      cursor: "pointer",
    }}
  >
    <ApplyShareMenu url={apprenticeshipData.ShareLink} />
  </Box> */}

  {/* Close Button */}
  <Button
    variant="contained"
    onClick={OnClose}
    sx={{
      minWidth: 40,
      width: 30,
      height: 30,
      borderRadius: "20%",
      backgroundColor: "#c90c4eff",
      color: "white",
      "&:hover": {
        backgroundColor: "#c90c4eff",
      },
    }}
  >
    <CloseIcon />
  </Button>
</Box>


</Box>
          {/* <Box display="flex" alignItems="center" gap={1} mb={2}>
            <Avatar src={apprenticeshipData.ProfileImage} />
            <Box>
              <Typography
                sx={{
                  ...typography.h4Bold,
                  color: theme.palette.primary.contrastText,
                }}
              >
                {apprenticeshipData.UserName}
              </Typography>
              <Typography
                sx={{
                  ...typography.bodyMedium,
                  color: theme.palette.info.main,
                }}
              >
                {apprenticeshipData.PostDuration}
              </Typography>
            </Box>
            <Chip
              label={apprenticeshipData.SourceType === "GW" ? "GIG" : apprenticeshipData.SourceType === "AP" ? "APRENTICESHIP" : "INTERNSHIP"}
              sx={{
                       color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.success.main, // ✅ proper success color
              }}
            />
           <Button
  variant="contained"
  onClick={OnClose}
  sx={{
     ml: "auto",     
    minWidth: "40px",
    width: "30px",
    height: "30px",
    borderRadius: "20%",        // round icon button
    backgroundColor: "#c90c4eff",     // red background
                       color: theme.palette.buttons.primary.text,
    "&:hover": {
      backgroundColor: "#c90c4eff", // darker red on hover
    },
  }}
>
  <CloseIcon  />
</Button> 
          </Box> */}

          {/* Gig Card */}
          <Card
            sx={{
              mb: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.border}`,
              bgcolor: theme.palette.card,
            }}
          >
            <CardContent>
              {/* Title Row */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <Typography
                  sx={{
                    ...typography.h2,
                    color: theme.palette.primary.contrastText,
                  }}
                >
                  {apprenticeshipData.Title}
                </Typography>

                {/* <IconButton
                  onClick={() => console.log("share clicked")}
                  sx={{ color: theme.palette.primary.contrastText }}
                >
                  <ShareIcon />
                </IconButton> */}
                   <ApplyShareMenu url={apprenticeshipData.ShareLink} />

              </Box>

              {apprenticeshipData.Applied === true ? (
                <Button

                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                     "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Applied
                </Button>
              ) : (
                <Button
                  onClick={async () => {
                    const idata = {
                      "RecordID": apprenticeshipData.RecordID,
                      "UserID": user.UserID,
                      "Type": apprenticeshipData.SourceType //Apprenticeship , IN-Internship , GW -Gigwork , JC- Job
                    };

                    console.log("idata", idata);

                    try {
                      const response = await OnApply(idata);

                      if (response?.payload?.Status === "Y") {
                        //setButtonName("Applied");
                        // setIsfollow(!isfollow);
                        // onFollowChange?.(data.UserID, !isfollow);
                      }
                    } catch (err) {
                      console.error(err);

                    }
                  }}
                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                     "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Apply
                </Button>
              )}
            </CardContent>
          </Card>

          {/* Job Description */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Job Responsibilities
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,

            }}

          >
            {apprenticeshipData.JobResponsibilities}
          </Typography>
          <Typography
            sx={{
              ...typography.bodySmall,
              color: theme.palette.secondary.contrastText,
            }}
            mb={2}
          >
            see translation
          </Typography>


          {/* Required Skills */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Required Skills
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
            {apprenticeshipData?.skills?.map((skill, i) => (
              <Chip
                key={i}
                label={skill.Name}
                variant="outlined"
                sx={{
                  ...typography.bodyLarge,
                  color: theme.palette.secondary.contrastText, // text color
                  bgcolor: theme.palette.card, // background color
                  borderColor: theme.palette.border, // optional: match your card border
                }}
              />
            ))}
          </Box>
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,

            }}
          >
            Work Method
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,

            }}
          >
            {apprenticeshipData.WorkType}
          </Typography>
          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />

          {/* About this role */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            About this role
          </Typography>
          {/* {Object.entries(jobData.roleDetails).map(([key, value]) => ( */}
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              StartDate
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {apprenticeshipData.StartDate}
            </Typography>
          </Box>
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Duration
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {apprenticeshipData.Duration}
            </Typography>
          </Box>
          {/* ))} */}

          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />
          {/* Reference Image */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Reference Image
          </Typography>
          <Box
            component="img"
            src={apprenticeshipData.ReferenceImage}
            alt="Reference"
            sx={{
              width: "100%", // full width of container
              height: 200, // fixed height
              objectFit: "cover", // ensures the image covers area without distortion
              borderRadius: 2,
              mb: 2,
            }}
          />

          {apprenticeshipData.Applied === true ? (
            <Button

              fullWidth
              variant="contained"
              sx={{
                ...typography.buttonPrimaryLarge,
                color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                mt: 3,
                borderRadius: "10px",
                 "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
              }}
            >
              Applied
            </Button>
          ) : (
            <Button
              onClick={async () => {
                const idata = {
                  "RecordID": apprenticeshipData.RecordID,
                  "UserID": user.UserID,
                  "Type": apprenticeshipData.SourceType //Apprenticeship , IN-Internship , GW -Gigwork , JC- Job
                };

                console.log("idata", idata);

                try {
                  const response = await OnApply(idata);

                  if (response?.payload?.Status === "Y") {
                    //setButtonName("Applied");
                    // setIsfollow(!isfollow);
                    // onFollowChange?.(data.UserID, !isfollow);
                  }
                } catch (err) {
                  console.error(err);

                }
              }}
              fullWidth
              variant="contained"
              sx={{
                ...typography.buttonPrimaryLarge,
                color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                mt: 3,
                borderRadius: "10px",
                 "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
              }}
            >
              Apply
            </Button>
          )}
        </>
      )}
      {job.SourceType === "IN" && (
        <>
          <Box 
          display="flex"
  alignItems={isMobile ? "flex-start" : "center"}
  justifyContent="space-between"
  flexDirection={isMobile ? "column" : "row"}
  gap={isMobile ? 1.5 : 2}
  mb={2}
           >

  {/* LEFT SIDE */}
  <Box display="flex" alignItems="center" gap={2} width="100%">
    <Avatar src={internshipData.ProfileImage} />

    <Box flexGrow={1}>
      <Typography
        sx={{
          ...typography.h4Bold,
          color: theme.palette.primary.contrastText,
        }}
      >
        {internshipData.UserName}
      </Typography>

      <Typography
        sx={{
          ...typography.bodyMedium,
          color: theme.palette.info.main,
        }}
      >
        {internshipData.PostDuration}
      </Typography>
    </Box>

    <Chip
     label={"INTERNSHIP"}
      // label={
      //   internshipData.SourceType === "JC"
      //     ? "JOB"
      //     : internshipData.SourceType === "AP"
      //     ? "APRENTICESHIP"
      //     : "INTERNSHIP"
      // }
      sx={{
        color: theme.palette.buttons.primary.text,
        bgcolor: theme.palette.success.main,
      }}
    />
  </Box>

  {/* RIGHT SIDE ACTIONS */}
<Box display="flex" gap={1} width={isMobile ? "100%" : "auto"}
>
  
  {/* Share Menu Button */}
  {/* <Box
    sx={{
      width: 32,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "20%",
      bgcolor: "#E3F2FD",
      color: "#1976d2",
      cursor: "pointer",
    }}
  >
    <ApplyShareMenu url={internshipData.ShareLink} />
  </Box> */}

  {/* Close Button */}
  <Button
    variant="contained"
     fullWidth={isMobile}
    onClick={OnClose}
    sx={{
      minWidth: 40,
      width: 30,
      height: 30,
      borderRadius: "20%",
      backgroundColor: "#c90c4eff",
      color: "white",
      "&:hover": {
        backgroundColor: "#c90c4eff",
      },
    }}
  >
    <CloseIcon />
  </Button>
</Box>


</Box>

          {/* Gig Card */}
          <Card
            sx={{
              mb: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.border}`,
              bgcolor: theme.palette.card,
            }}
          >
            <CardContent>
              {/* Title Row */}
              <Box
                      display="flex"
  flexDirection={isMobile ? "column" : "row"}
  alignItems={isMobile ? "flex-start" : "center"}
  justifyContent="space-between"
  gap={1}
                // sx={{
                //   display: "flex",
                //   alignItems: "center",
                //   justifyContent: "space-between",
                // }}
              >
                <Typography
                  sx={{
                    ...typography.h2,
                    color: theme.palette.primary.contrastText,
                  }}
                >
                  {internshipData.Title}
                </Typography>

                {/* <IconButton
                  onClick={() => console.log("share clicked")}
                  sx={{ color: theme.palette.primary.contrastText }}
                >
                  <ShareIcon />
                </IconButton> */}
                                   <ApplyShareMenu url={internshipData.ShareLink} />

              </Box>

              {internshipData.Applied === true ? (
                <Button

                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                      "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Applied
                </Button>
              ) : (
                <Button
                  onClick={async () => {
                    const idata = {
                      "RecordID": internshipData.RecordID,
                      "UserID": user.UserID,
                      "Type": internshipData.SourceType //Apprenticeship , IN-Internship , GW -Gigwork , JC- Job
                    };

                    console.log("idata", idata);

                    try {
                      const response = await OnApply(idata);

                      if (response?.payload?.Status === "Y") {
                        //setButtonName("Applied");
                        // setIsfollow(!isfollow);
                        // onFollowChange?.(data.UserID, !isfollow);
                      }
                    } catch (err) {
                      console.error(err);

                    }
                  }}
                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                      "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Apply
                </Button>
              )}
            </CardContent>
          </Card>

          {/* Job Description */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Job Responsibilities
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,

            }}

          >
            {internshipData.JobResponsibilities}
          </Typography>
          <Typography
            sx={{
              ...typography.bodySmall,
              color: theme.palette.secondary.contrastText,
            }}
            mb={2}
          >
            see translation
          </Typography>


          {/* Required Skills */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Required Skills
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
            {internshipData?.skills?.map((skill, i) => (
              <Chip
                key={i}
                label={skill.Name}
                variant="outlined"
                sx={{
                  ...typography.bodyLarge,
                  color: theme.palette.secondary.contrastText, // text color
                  bgcolor: theme.palette.card, // background color
                  borderColor: theme.palette.border, // optional: match your card border
                }}
              />
            ))}
          </Box>
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,

            }}
          >
            Work Method
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,

            }}
          >
            {internshipData.WorkType}
          </Typography>
          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />

          {/* About this role */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            About this role
          </Typography>
          {/* {Object.entries(jobData.roleDetails).map(([key, value]) => ( */}
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              StartDate
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {internshipData.StartDate}
            </Typography>
          </Box>
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Duration
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {internshipData.Duration}
            </Typography>
          </Box>
          {/* ))} */}

          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />
          {/* Reference Image */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Reference Image
          </Typography>
          <Box
            component="img"
            src={internshipData.ReferenceImage}
            alt="Reference"
            sx={{
              width: "100%", // full width of container
              height: 200, // fixed height
              objectFit: "cover", // ensures the image covers area without distortion
              borderRadius: 2,
              mb: 2,
            }}
          />


          {internshipData.Applied === true ? (
            <Button

              fullWidth
              variant="contained"
              sx={{
                ...typography.buttonPrimaryLarge,
                color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                mt: 3,
                borderRadius: "10px",
                  "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
              }}
            >
              Applied
            </Button>
          ) : (
            <Button
              onClick={async () => {
                const idata = {
                  "RecordID": internshipData.RecordID,
                  "UserID": user.UserID,
                  "Type": internshipData.SourceType //Apprenticeship , IN-Internship , GW -Gigwork , JC- Job
                };

                console.log("idata", idata);

                try {
                  const response = await OnApply(idata);

                  if (response?.payload?.Status === "Y") {
                    //setButtonName("Applied");
                    // setIsfollow(!isfollow);
                    // onFollowChange?.(data.UserID, !isfollow);
                  }
                } catch (err) {
                  console.error(err);

                }
              }}
              fullWidth
              variant="contained"
              sx={{
                ...typography.buttonPrimaryLarge,
                color: theme.palette.buttons.primary.text,
                bgcolor: theme.palette.buttons.primary.bg,
                mt: 3,
                borderRadius: "10px",
                  "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
              }}
            >
              Apply
            </Button>
          )}
        </>
      )}
      {job.SourceType === "JC" && (
        <>
          {/* <Box display="flex" alignItems="center" justifyContent="space-between" mb={2}> */}
  <Box 
          display="flex"
  alignItems={isMobile ? "flex-start" : "center"}
  justifyContent="space-between"
  flexDirection={isMobile ? "column" : "row"}
  gap={isMobile ? 1.5 : 2}
  mb={2}
           >
  {/* LEFT SIDE */}
  <Box display="flex" alignItems="center" gap={2} width="100%">
    <Avatar src={JobData.ProfileImage} />

    <Box flexGrow={1}>
      <Typography
        sx={{
          ...typography.h4Bold,
          color: theme.palette.primary.contrastText,
        }}
      >
        {JobData.UserName}
      </Typography>

      <Typography
        sx={{
          ...typography.bodyMedium,
          color: theme.palette.info.main,
        }}
      >
        {JobData.PostDuration}
      </Typography>
    </Box>

    <Chip
    // label={
    //   "JOBjiii"
    // }
      label={
        JobData.SourceType === "JC"
          ? "JOB"
          : JobData.SourceType === "AP"
          ? "APRENTICESHIP"
          : "INTERNSHIP"
      }
      sx={{
        color: theme.palette.buttons.primary.text,
        bgcolor: theme.palette.success.main,
      }}
    />
  </Box>

  {/* RIGHT SIDE ACTIONS */}
<Box display="flex" alignItems="center" gap={1}>
  
  {/* Share Menu Button */}
  {/* <Box
    sx={{
      width: 32,
      height: 32,
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      borderRadius: "20%",
      bgcolor: "#E3F2FD",
      color: "#1976d2",
      cursor: "pointer",
    }}
  >
    <ApplyShareMenu url={JobData.ShareLink} />
  </Box> */}

  {/* Close Button */}
  <Button
    variant="contained"
    onClick={OnClose}
    sx={{
      minWidth: 40,
      width: 30,
      height: 30,
      borderRadius: "20%",
      backgroundColor: "#c90c4eff",
      color: "white",
      "&:hover": {
        backgroundColor: "#c90c4eff",
      },
    }}
  >
    <CloseIcon />
  </Button>
</Box>


</Box>


          {/* Gig Card */}
          <Card
            sx={{
              mb: 2,
              borderRadius: 2,
              border: `1px solid ${theme.palette.border}`,
              bgcolor: theme.palette.card,
            }}
          >
            <CardContent>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
              <Typography
                sx={{
                  ...typography.h2,
                  color: theme.palette.primary.contrastText,
                }}
              >
                {JobData.Title}
              </Typography>
                  <ApplyShareMenu url={JobData.ShareLink} />
</Box>
              <Typography
                sx={{
                  ...typography.buttonGhost,
                  color: theme.palette.primary.contrastText,
                }}
              >
                {JobData.DepartmentName} • {JobData.EmployeeType} •{JobData.Location} •
                {JobData.ExperienceBand}
              </Typography>
              {JobData.Applied === true ? (
                <Button

                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                    "&:hover": {
                       color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Applied
                </Button>
              ) : (
                <Button
                  onClick={async () => {
                    const idata = {
                      "RecordID": JobData.RecordID,
                      "UserID": user.UserID,
                      "Type": JobData.SourceType //Apprenticeship , IN-Internship , GW -Gigwork , JC- Job
                    };

                    console.log("idata", idata);
                    OnApply(idata);


                  }}
                  fullWidth
                  variant="contained"
                  sx={{
                    ...typography.buttonPrimaryLarge,
                    color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                    mt: 3,
                    borderRadius: "10px",
                       "&:hover": {
                      color: theme.palette.buttons.primary.text,
                    bgcolor: theme.palette.buttons.primary.bg,
                      },
                  }}
                >
                  Apply
                </Button>
              )}
            </CardContent>
          </Card>

          {/* Job Description */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Role Summary
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,

            }}

          >
            {JobData.Summary}
          </Typography>
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Responsibilities
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,

            }}

          >
            {JobData.Responsibilities}
          </Typography>
          <Typography
            sx={{
              ...typography.bodySmall,
              color: theme.palette.secondary.contrastText,
            }}
            mb={2}
          >
            see translation
          </Typography>


          {/* Required Skills */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Required Skills
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
            {JobData?.skills?.map((skill, i) => (
              <Chip
                key={i}
                label={skill.Name}
                variant="outlined"
                sx={{
                  ...typography.bodyLarge,
                  color: theme.palette.secondary.contrastText, // text color
                  bgcolor: theme.palette.card, // background color
                  borderColor: theme.palette.border, // optional: match your card border
                }}
              />
            ))}
          </Box>
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,

            }}
          >
            Work Method
          </Typography>
          <Typography
            sx={{
              ...typography.bodyLarge,
              color: theme.palette.info.main,

            }}
          >
            {JobData.WorkType}
          </Typography>
          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />

          {/* About this role */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            About this role
          </Typography>
          {/* {Object.entries(jobData.roleDetails).map(([key, value]) => ( */}
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Apply Before
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {JobData.DeadLineDate}
            </Typography>
          </Box>
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Compensation
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {JobData.Compensation || "Compensation"}
            </Typography>
          </Box>
           <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Duration
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {JobData.Duration}
            </Typography>
          </Box>
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Salary
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
             {"₹" + JobData.RateRange}
            </Typography>
          </Box>
           <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Production Status
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {JobData.ProductionStatus || "ProductionStatus"}
            </Typography>
          </Box>
          <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Work Days
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {JobData.WorkHourName}
            </Typography>
          </Box>
           <Box
            //key={key}
            display="flex"
            justifyContent="space-between"
            my={0.5}
          >
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.info.main,
              }}
            >
              Wok Arrangement
              {/* {key.charAt(0).toUpperCase() +
                  key.slice(1).replace(/([A-Z])/g, " $1")} */}
            </Typography>
            <Typography
              sx={{
                ...typography.bodyLarge,
                color: theme.palette.secondary.contrastText,
              }}
            >
              {JobData.WorkType}
            </Typography>
          </Box>
         
          {/* ))} */}
                    <Divider sx={{ my: 2, borderColor: theme.palette.border }} />

    {/* Tools Software */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Tools/Software
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
            {JobData?.software?.map((software, i) => (
              <Chip
                key={i}
                label={software.Name}
                variant="outlined"
                sx={{
                  ...typography.bodyLarge,
                  color: theme.palette.secondary.contrastText, // text color
                  bgcolor: theme.palette.card, // background color
                  borderColor: theme.palette.border, // optional: match your card border
                }}
              />
            ))}
          </Box>
                    <Divider sx={{ my: 2, borderColor: theme.palette.border }} />

              {/* benefits */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Benefit
          </Typography>
          <Box display="flex" flexWrap="wrap" gap={1} mb={2}>
            {JobData?.benefits?.map((benefit, i) => (
              <Chip
                key={i}
                label={benefit.Name}
                variant="outlined"
                sx={{
                  ...typography.bodyLarge,
                  color: theme.palette.secondary.contrastText, // text color
                  bgcolor: theme.palette.card, // background color
                  borderColor: theme.palette.border, // optional: match your card border
                }}
              />
            ))}
          </Box>
          <Divider sx={{ my: 2, borderColor: theme.palette.border }} />
          <Box sx={{ p: 2 }}>
      {/* Title */}
      <Typography
        variant="h5"
        fontWeight="bold"
        gutterBottom
        sx={{ mb: 3 }}
      >
        Education
      </Typography>

      {/* List */}
      {JobData?.education?.map((item) => (
        <Typography
          key={item.RecordID}
          variant="h6"
          fontWeight="500"
          sx={{ mb: 2 }}
        >
          * {item.Name}
        </Typography>
      ))}
    </Box>
                        <Divider sx={{ my: 2, borderColor: theme.palette.border }} />

          {/* Reference Image */}
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            Nice to Have
          </Typography>
          <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            {JobData.Test || "Test"}
          </Typography>

<Formik initialValues={{
  questions:""
}} onSubmit={handleSubmit}>
  {({ values }) => (      // ✅ FIXED: get formik values here
    <Form>
      <Box sx={{ p: 2 }}>
  {JobData.questions && JobData.questions.length > 0 && (
<>
        {JobData?.questions
        //this is showed only textkey uestions only
         .filter(q => q.Question && q.Question.trim() !== "")
         
        .map(q => (
          <Box key={q.RecordID} sx={{ mb: 2 }}>
              <Typography
            sx={{
              ...typography.h3,
              color: theme.palette.primary.contrastText,
            }}
          >
            {q.Question}
          </Typography>
            <Field
              name={q.RecordID}
              as={TextField}
              fullWidth
              label="Type your answer"
              // label={q.Question}
              variant="outlined"
            />
          </Box>
        ))}
        </>
      )}
      </Box>

      {JobData.Applied === true ? (
        <Button
          fullWidth
          variant="contained"
          sx={{
            ...typography.buttonPrimaryLarge,
            color: theme.palette.buttons.primary.text,
            bgcolor: theme.palette.buttons.primary.bg,
            mt: 3,
            borderRadius: "10px",
               "&:hover": {
                   color: theme.palette.buttons.primary.text,
            bgcolor: theme.palette.buttons.primary.bg,
                      },
          }}
        >
          Applied
        </Button>
      ) : (
        <Button
          onClick={async () => {
            // ✅ FORMAT ANSWERS HERE
            const formattedAnswers = {
              Answers: JobData?.questions.map(q => ({
                QuestionID: q.RecordID,
                Answer: values[q.RecordID] || ""
              }))
            };

            console.log("formattedAnswers:", formattedAnswers);

            const idata = {
              RecordID: JobData.RecordID,
              UserID: user.UserID,
              Type: JobData.SourceType,
              Answers: formattedAnswers.Answers,
            };

            console.log("idata:", idata);

            try {
              const response = await OnApply(idata);
              if (response?.payload?.Status === "Y") {
                console.log("Applied successfully!");
              }
            } catch (err) {
              console.error(err);
            }
          }}
          fullWidth
          variant="contained"
          sx={{
            ...typography.buttonPrimaryLarge,
            color: theme.palette.buttons.primary.text,
            bgcolor: theme.palette.buttons.primary.bg,
            mt: 3,
            borderRadius: "10px",
             "&:hover": {
               color: theme.palette.buttons.primary.text,
            bgcolor: theme.palette.buttons.primary.bg,
                      },
          }}
        >
          Apply
        </Button>
      )}
    </Form>
  )}
</Formik>

        </>
      )}
    </Box>
  );
};

export default JobDetails;
// import React, { useEffect, useState } from "react";
// import {
//   Box,
//   Typography,
//   Avatar,
//   Button,
//   Divider,
//   Stack,
//   Paper,Grid,
//   Chip,
//   IconButton,Tooltip
// } from "@mui/material";
// import { useDispatch, useSelector } from "react-redux";
// import { useNavigate, useParams } from "react-router-dom";
// import { GetApprenticeshipById, GetGigWorkById, GetInternshipById } from "app/redux/slice/getSlice";
// import Swal from 'sweetalert2';
// import { AddBookMark, PostApply } from "app/redux/slice/postSlice";
// import useAuth from "app/hooks/useAuth";
// import { Formik } from "formik";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import { ArrowBack } from "@mui/icons-material";
// import BackBtn from "app/components/BackBtn";
// const JobDetail = () => {
// const navigate=useNavigate();
// const dispatch=useDispatch();
// const params=useParams();
//   const [submitAction, setSubmitAction] = useState(null);
// // const {user}=useAuth();
//   const user={
//     UserID: 1,
//     role: "ADMIN",
//     name: "Safin",
//     username: "safin2001",
//     email: "safin@gmail.com",
//     avatar: "/assets/images/user.jpg",
//     company:"Plymouth",
//     bio: "Enthusiastic software developer with a passion for building intuitive user interfaces.",
//   dateofbirth: "1998-06-15", // Example date
//   Location: "Chennai, India",
//   height: "175 cm",
//   weight: "70 kg",
//   age: 27,
//   education: {
//     degree: "B.Tech",
//     field: "Computer Science",
//     university: "Anna University",
//     graduationYear: 2020
//   },
//   languages: ["Tamil", "English", "Hindi", "Telugu", "Kannada"]
//   };
//   const initialValues = {
//     UserID: user.UserID || "",
//     RecordID: params.id,
//     Type: params.mode
//   };
// //==============================REDUXSTATTE=============================//

// useEffect(()=>{
// if(params.mode === "GW"){
//   dispatch(GetGigWorkById({RecordID:params.id}))
// }else if(params.mode === "AP"){
// dispatch(GetApprenticeshipById({RecordID:params.id}))
// }else{
//   dispatch(GetInternshipById({RecordID:params.id}))
// }

// },[dispatch,params.id]);
// const gigWorkData = useSelector((state) => state.getSlice.getGigWorkByIdData);
// const internshipData = useSelector((state) => state.getSlice.getInternshipByIdData);
// const apprenticeshipData = useSelector((state) => state.getSlice.getApprenticeshipByIdData);

// // Decide which one to use
// let data;

// if (params.mode === "GW") {
//   data = gigWorkData;
// } else if (params.mode === "AP") {
//   data = apprenticeshipData;
// } else {
//   data = internshipData;
// }

// console.log(data);

// //===================Apply============================================
// const handleApplySubmit = async (values) => {

//   console.log(values);

//     try {
//       const response = await dispatch(PostApply({ idata: values }));

//       if (response.payload.Status === "Y") {
//         Swal.fire({
//           Title: 'Success',
//           text: response.payload.Message,
//           icon: 'success',
//           confirmButtonColor: '#3085d6',
//           confirmButtonText: 'OK',
//         }).then(()=>{
//           if(params.mode === "GW"){
//   dispatch(GetGigWorkById({RecordID:params.id}))
// }else if(params.mode === "AP"){
// dispatch(GetApprenticeshipById({RecordID:params.id}))
// }else{
//   dispatch(GetInternshipById({RecordID:params.id}))
// }
//         });
//       } else {
//         Swal.fire({
//           Title: 'Failed',
//           text: response.payload.Message || 'Something went wrong!',
//           icon: 'error',
//           confirmButtonText: 'Try Again',
//         });
//       }
//     } catch (err) {
//       console.error(err);
//       Swal.fire({
//         title: 'Error',
//         text: 'Network or server error occurred!',
//         icon: 'error',
//         confirmButtonText: 'Retry',
//       });
//     }
//   };

//   //==========SAVED==================
//   const handleBookmark = async () => {
//     const idata={
// UserID: user.UserID || "",
//     RecordID: params.id,
//     Type: params.mode === "G" ? "GW" : params.mode === "A" ? "AP" : "IN"
//     };
//       try {
//         const response = await dispatch(AddBookMark(idata));
//         if (response.payload?.Status === "Y") {
//            Swal.fire({
//           title: 'Success',
//           text: response.payload.Message,
//           icon: 'success',
//           confirmButtonColor: '#3085d6',
//           confirmButtonText: 'OK',
//         }).then(()=>{
//           if(params.mode === "GW"){
//   dispatch(GetGigWorkById({RecordID:params.id}))
// }else if(params.mode === "AP"){
// dispatch(GetApprenticeshipById({RecordID:params.id}))
// }else{
//   dispatch(GetInternshipById({RecordID:params.id}))
// }
//         });

//         } else {
//           Swal.fire("Error", response.payload.Message || "Something went wrong", "error");
//         }
//         return response;
//       } catch (err) {
//         Swal.fire("Error", "Network or server issue", "error");
//         throw err;
//       }
//     };
//   return (

//   <Box sx={{ width: "100%", mx: "auto", p: 2, pb: 8 }}>
//       {/* <Box sx={{
//                      display:"flex",
//                      justifyContent:"flex-end",
//                      mb:1
//                      }}>
//                      <IconButton
//                      size="small"
//                     onClick={() => navigate(-1)}
//                     sx={{
//                      borderRadius:"5px",
//                      border:"1px solid #eee",
//                      }}>
//                          <ArrowBack fontSize="small"/>
//                          <Typography variant="body1">Back</Typography>
//                      </IconButton>
//                  </Box> */}
//                  <BackBtn/>
//     <Formik initialValues={initialValues} enableReinitialize
//     onSubmit={async (values) => {
//         if (submitAction === 'save') {
//           await handleBookmark();  // Save and reset form
//         } else if (submitAction === 'apply') {
//           await handleApplySubmit(values); // Navigate only if data exists
//           // resetForm();
//         }
//       }}>
//       {({ handleSubmit }) => (
//         <form onSubmit={handleSubmit}>
//       {/* Header */}

//       {/* Info Section */}
//       <Box
//   sx={{
//     borderRadius: 2,
//     overflow: "hidden",
//     bgcolor: "#fff",
//     boxShadow: 1,
//   }}
// >
//   {/* Cover Image Wrapper */}
//  <Box
//   sx={{
//     width: "100%",                        // Full width
//     minHeight: 300,                       // Minimum height
//     maxHeight: 600,                       // Max height if needed
//     backgroundImage: data?.CoverImage ? `url(${data.CoverImage})` : "none",
//     backgroundSize: "cover",              // Fill entire box (may crop)
//     backgroundRepeat: "no-repeat",        // No tiling
//     backgroundPosition: "center",         // Center the image
//     position: "relative",                 // Required for absolutely positioned children like Avatar
//   }}
// >

//     <Avatar
//       src={data?.ProfileImage}
//       sx={{
//         width: 80,
//         height: 80,
//         border: "3px solid white",
//         position: "absolute",
//         bottom: -40,
//         left: 16,
//       }}
//     />
//   </Box>

// {/* Info Section */}
// <Box sx={{ pt: 6, px: 2, pb: 2 }}>
//   <Typography variant="h6" fontWeight="bold">
//     {data?.UserName}
//   </Typography>

//   {/* Gig Work Mode */}
//   {params.mode === "GW" && (
//     <>
//       <Typography variant="body2" color="text.secondary">
//         {data?.GigWorkType}
//       </Typography>

//       <Stack direction="row" justifyContent="space-between" mt={1}>
//         <Typography variant="body1" sx={{ color: "#FFA000", fontWeight: 600 }}>
//           {data?.Price}/{data?.PriceType}
//         </Typography>
//         <Typography variant="caption" color="text.secondary">
//           9 days left
//         </Typography>
//       </Stack>
//     </>
//   )}

//   {/* Internship or Apprenticeship Mode */}
//   {(params.mode === "IN" || params.mode === "AP") && (
//     <Typography variant="body2" color="text.secondary">
//       {data?.Desigination}
//     </Typography>
//   )}
// </Box>
// </Box>

// {/* Render only if mode is "G" */}
// {params.mode === "GW" && (
//   <Box p={2}>
//     {/* Header */}
//     <Typography variant="h6" fontWeight="bold" textAlign="center" mb={2}>
//       Job Details
//     </Typography>

//     {/* Job Description */}
//     <Typography variant="subtitle1" fontWeight="medium">
//       Job Description
//     </Typography>
//     <Typography variant="body2" color="text.secondary" mb={2}>
//       {data.ShortDescription}
//     </Typography>

//     {/* Requirements Section */}
//     <Typography variant="subtitle1" fontWeight="medium" mb={1}>
//       Requirements
//     </Typography>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//         Project Name
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.ProjectName}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//         Stage
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.ProgressStage}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//         Work Type
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.WorkTypeName}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//         Work Hours
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.WorkHours}/{data.WorkHoursTime}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     {/* Skills Section */}
//     <Typography variant="subtitle1" fontWeight="medium" mt={2}>
//       Skills Required
//     </Typography>
//     <Box display="flex" gap={1} flexWrap="wrap" mb={4}>
//       {data?.skills?.map((item) => (
//         <Chip key={item.RecordID} label={item.Name} />
//       ))}
//     </Box>

//     {/* Action Buttons */}
//      <Stack direction="row" justifyContent="space-between">

//       {data.IsSaved === false ?(
//       <Button variant="outlined" fullWidth sx={{ mr: 1 }} type="submit" onClick={() => setSubmitAction('save')} >
//         Save
//       </Button>
//       ):(
//         <Button variant="outlined" fullWidth sx={{ mr: 1 }} disabled >
//         Save
//       </Button>
//       )}
//       {data.IsApplied === false ? (
//       <Button variant="contained" fullWidth sx={{ ml: 1 }} type="submit"  onClick={() => setSubmitAction('apply')}>
//         Apply Now
//       </Button>):(
//          <Button variant="contained" fullWidth sx={{ ml: 1 }}  disabled>
//         Apply Now
//       </Button>
//       )}
//     </Stack>
//   </Box>
// )}
// {(params.mode === "IN" || params.mode === "AP") && (
//   <Box p={2}>
//     {/* Header */}
//     <Typography variant="h6" fontWeight="bold" textAlign="center" mb={2}>
//       Job Details
//     </Typography>

//     {/* Job Description */}
//     <Typography variant="subtitle1" fontWeight="medium">
//       Job Description
//     </Typography>
//     <Typography variant="body2" color="text.secondary" mb={2}>
//       {data.Responsibility}
//     </Typography>

//     {/* Requirements Section */}
//     <Typography variant="subtitle1" fontWeight="medium" mb={1}>
//       Requirements
//     </Typography>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//        Title
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.Title}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//         Organiation Name
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.OrganiationName}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//         Work Type
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.TypeName}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     <Box mb={2}>
//       <Typography variant="body2" fontWeight="bold">
//       Start and Duration
//       </Typography>
//       <Typography variant="body2" color="text.secondary">
//         {data.StartDate}-{data.Duration}
//       </Typography>
//       <Divider sx={{ mt: 1 }} />
//     </Box>

//     {/* Skills Section */}
//     <Typography variant="subtitle1" fontWeight="medium" mt={2}>
//       Skills Required
//     </Typography>
//     <Box display="flex" gap={1} flexWrap="wrap" mb={4}>
//       {data?.skills?.map((item) => (
//         <Chip key={item.RecordID} label={item.Name} />
//       ))}
//     </Box>

//     {/* Action Buttons */}
//      <Stack direction="row" justifyContent="space-between">

//       {data.IsSaved === false ?(
//       <Button variant="outlined" fullWidth sx={{ mr: 1 }} type="submit" onClick={() => setSubmitAction('save')} >
//         Save
//       </Button>
//       ):(
//         <Button variant="outlined" fullWidth sx={{ mr: 1 }} disabled >
//         Save
//       </Button>
//       )}
//       {data.IsApplied === false ? (
//       <Button variant="contained" fullWidth sx={{ ml: 1 }} type="submit"  onClick={() => setSubmitAction('apply')}>
//         Apply Now
//       </Button>):(
//          <Button variant="contained" fullWidth sx={{ ml: 1 }}  disabled>
//         Apply Now
//       </Button>
//       )}
//     </Stack>
//   </Box>
// )}
// </form>
//       )}
//     </Formik>
//     </Box>
//   );
// };

// export default JobDetail;









//===================================vds=============================================//
{/* {jobData.similarJobs.map((job, i) => (
        <Card key={i} sx={{ mt: 1, borderRadius: 2 }}>
          <CardContent>
            <Typography fontWeight="bold">{job.Title}</Typography>
            <Typography variant="body2" color="text.secondary">
              {job.type} • {job.Location}
            </Typography>
            <Box display="flex" gap={1} mt={1}>
              {job.tags.map((tag, idx) => (
                <Chip key={idx} label={tag} size="small" />
              ))}
            </Box>
          </CardContent>
        </Card>
      ))} */}

{/* <Box
            display="flex"
            overflow="auto"
            gap={2}
            mt={2}
            sx={{
              "&::-webkit-scrollbar": { display: "none" }, // hide scrollbar
            }}
          >
            {jobData.similarJobs.map((job, i) => (
              <Card
                key={i}
                sx={{
                  flex: "0 0 48%", // show 2 cards in a row when scrolling
                  borderRadius: 3,
                  boxShadow: "0px 2px 8px rgba(0,0,0,0.08)",
                  border: `1px solid ${theme.palette.border}`,
                  bgcolor: theme.palette.card,
                }}
              >
                <CardContent>
                  {/* Top Row
                  <Box
                    display="flex"
                    justifyContent="space-between"
                    alignItems="center"
                  >
                    <Avatar
                      src={job.icon || "https://mui.com/static/logo.png"}
                      sx={{ width: 32, height: 32 }}
                    />
                    <Chip
                      label="GIG"
                      size="small"
                      sx={{
                        backgroundColor: "#E6FAF3",
                        color: "#00A67E",
                        fontWeight: "bold",
                      }}
                    />
                  </Box>

                  {/* Title
                  <Typography
                    sx={{
                      ...typography.bodyLarge,
                      color: theme.palette.primary.contrastText,
                    }}
                    mt={1}
                  >
                    {job.Title}
                  </Typography>

                  {/* Location }
                  <Typography
                    sx={{
                      ...typography.bodyLarge,
                      color: theme.palette.primary.contrastText,
                    }}
                  >
                    {job.type} •{" "}
                    <span
                      style={{
                        ...typography.bodyLarge,
                        color: theme.palette.secondary.main,
                      }}
                    >
                      {job.Location}
                    </span>
                  </Typography>

                  {/* Tags 
                  <Box display="flex" gap={1} flexWrap="wrap" mt={1}>
                    {job.tags.map((tag, idx) => (
                      <Chip
                        key={idx}
                        label={tag}
                        size="small"
                        sx={{
                          borderRadius: "20px",
                          border: "1px solid",
                          borderColor: idx % 2 === 0 ? "#FFB84D" : "#6C63FF",
                          color: idx % 2 === 0 ? "#FFB84D" : "#6C63FF",
                          backgroundColor: "transparent",
                          fontWeight: "500",
                        }}
                      />
                    ))}
                  </Box>
                </CardContent>
              </Card>
            ))}
          </Box> */}


    //       {
    //     "RecordID": 77,
    //     "UserID": 104,
    //     "DepartmentID": 1,
    //     "DepartmentName": "Direction",
    //     "Title": "Director",
    //     "UserName": "Lalitha Sri",
    //     "ProjectID": 184,
    //     "ProjectTitle": "Software",
    //     "WorkHourID": 3,
    //     "WorkHourName": "Flexible schedule",
    //     "EmployeeType": "4",
    //     "EmployeeTypeName": "Project-based",
    //     "Location": "Chennai",
    //     "WorkType": "Remote",
    //     "RateRange": "1000-35550",
    //     "Benefits": null,
    //     "ExperienceBand": "1\u20133 years (Junior)",
    //     "IsDraft": 0,
    //     "Summary": "Director related jobs",
    //     "OtherSummary": "Director related jobs",
    //     "Responsibilities": "Directions",
    //     "OtherResponsibilities": "Directions",
    //     "NicetoHave": "Photography",
    //     "OtherNicetoHave": "Photography",
    //     "DeadLineDate": "06 Dec 2025",
    //     "CreatedDateTime": "2025-11-06 14:57:57",
    //     "AppliedCount": 1,
    //     "ViewCount": null,
    //     "ApplicationStatus": "LV",
    //     "Software": null,
    //     "SourceType": "JC",
    //     "ProductionStausID": null,
    //     "ProductionStatus": null,
    //     "CompensationID": null,
    //     "Compensation": null,
    //     "Applied": true,
    //     "ShareLink": "https:\/\/dvmtcreaapi.bexatm.com\/api\/Share\/Nzc=?link=eyJUeXBlIjoiSkMiLCJVc2VySUQiOjEsInRpbWVzdGFtcCI6MTc2MzM1ODg5Mn0%3D",
    //     "ProfileImage": "https:\/\/dvmtcreaapi.bexatm.com\/public\/uploads\/Profile\/Profile\/20251106_130024.jpeg",
    //     "PostDuration": "11 days ago",
    //     "StatusLabel": "Live",
    //     "skills": [
    //         {
    //             "RecordID": 215,
    //             "SkillID": 1,
    //             "Name": "Creative Direction"
    //         },
    //         {
    //             "RecordID": 216,
    //             "SkillID": 2,
    //             "Name": "Visual Storytelling"
    //         },
    //         {
    //             "RecordID": 217,
    //             "SkillID": 3,
    //             "Name": "Blocking & Staging"
    //         },
    //         {
    //             "RecordID": 218,
    //             "SkillID": 5,
    //             "Name": "Screen Writing"
    //         },
    //         {
    //             "RecordID": 219,
    //             "SkillID": 8,
    //             "Name": "Story Development"
    //         },
    //         {
    //             "RecordID": 220,
    //             "SkillID": 9,
    //             "Name": "Camera Operation"
    //         }
    //     ],
    //     "questions": [],
    //     "software": [],
    //     "benefits": [],
    //     "education": [],
    //     "industryspecifics": []
    // }